/* global Vimeo */

import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    const body = $('body');

    // Scroll distance of the body -- used for modals
    let bodyScrollDistance = 0;
    let bodyAdminBarOffset = 0;

    if (body.hasClass('admin-bar')) {
      if ($(window).width() > 783) {
        bodyAdminBarOffset = 32;
      } else {
        bodyAdminBarOffset = 46;
      }
    }

    const globalCareersHero = $('section.global-careers-hero');
    if (globalCareersHero.length) {
      const signupModalTrigger = globalCareersHero.find('.signup-modal-trigger');
      const signupModal = globalCareersHero.find('.signup-modal');
      const modalDimmer = globalCareersHero.find('.signup-dimmer');

      signupModalTrigger.on('click', () => {
        signupModal.addClass('shown');

        // Add top bodyScroll
        bodyScrollDistance = $(window).scrollTop();
        body.css('top', (bodyScrollDistance - bodyAdminBarOffset) * -1);
        body.addClass('modal-open');
      });

      modalDimmer.on('click', () => {
        signupModal.removeClass('shown');
        body.removeClass('modal-open');

        // Remove top bodyScroll
        body.css('top', '');
        $(window).scrollTop(bodyScrollDistance);
      });

      // scroll passed
      const buttonsWrapper = globalCareersHero.find('.buttons-wrapper');
      const heroFixed = globalCareersHero.find('.hero-fixed');

      helpers.onWindowEvents(() => {
        const currentScroll = $(window).scrollTop();
        const buttonWrapTop = buttonsWrapper.offset().top;
        const buttonWrapOffset = buttonsWrapper.height() + buttonWrapTop;
        let offset = 0;

        if ( body.hasClass('admin-bar') ) {
          offset -= helpers.adminBarHeight();
        }

        if ( currentScroll > buttonWrapOffset + offset ) {
          heroFixed.addClass('sticky-show');
        } else {
          heroFixed.removeClass('sticky-show');
        }
      }, 0, 1, 1, 1);
    }

    const globalCareersTestimonials = $('section.global-careers-testimonials');
    if (globalCareersTestimonials.length) {
      const slider = globalCareersTestimonials.find('.testimonials-slider');
      const prevArrow = globalCareersTestimonials.find('.prev');
      const nextArrow = globalCareersTestimonials.find('.next');

      slider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        fade: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              fade: false,
            },
          },
        ],
      });

      helpers.equalHeightElements('section.global-careers-testimonials .equal-height');
    }

    const globalCareersLocations = $('section.global-careers-locations');
    if (globalCareersLocations.length) {
      const slider = globalCareersLocations.find('.locations-slider');
      const prevArrow = globalCareersLocations.find('.prev');
      const nextArrow = globalCareersLocations.find('.next');

      slider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      const locationItem = globalCareersLocations.find('.location-item');
      locationItem.each(function() {
        const _this = $(this);
        const description = _this.find('.location-item-description').get(0);

        _this.on('mouseover', () => {
          description.style.height = description.scrollHeight + 'px';
        }).on('mouseout', () => {
          description.style.height = null;
        });
      });
    }

    const globalCareersValues = $('section.global-careers-values');
    if (globalCareersValues.length) {
      const valueItemTab = globalCareersValues.find('.value-item-tab');
      const valueItemImage = globalCareersValues.find('.value-item-image-wrapper');
      const valueItemDetails = globalCareersValues.find('.value-item-details');

      valueItemTab.on('click', function(e) {
        e.preventDefault();

        const _this = $(this);
        const tab = _this.data('tab');
        const selectedImage = globalCareersValues.find(`.value-item-image-wrapper[data-tab='${tab}']`);
        const selectedDetails = globalCareersValues.find(`.value-item-details[data-tab='${tab}']`);

        valueItemTab.removeClass('active');
        valueItemImage.removeClass('active');
        valueItemDetails.removeClass('active');
        _this.addClass('active');
        selectedImage.addClass('active');
        selectedDetails.addClass('active');
      });
    }

    const globalCareersStats = $('section.global-careers-stats');
    if (globalCareersStats.length) {
      helpers.equalHeightElements('section.global-careers-stats .equal-height');
    }

    const globalCareersIntro = $('section.global-careers-intro');
    if (globalCareersIntro.length) {

      // https://github.com/vimeo/player.js
      if (Vimeo) {
        const videoWrapper = globalCareersIntro.find('.video-wrapper').first();
        const videoLayer = globalCareersIntro.find('.video-layer').get(0);
        const player = new Vimeo.Player(videoLayer);

        videoWrapper.on('click', () => {
          videoWrapper.addClass('playing');
          player.play();
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalCareers.js